export default "__VITE_ASSET__CqtA7N3c__"